// libs
import isEmpty from 'lodash/isEmpty';

// helpers
import Storage from 'shared/helpers/storage';

// constants
import { PLP_COACHMARK_VARIANTS } from 'shared/constants';
import { COACHMARK_SESSION_IDENTIFIER, COACHMARK_IDENTIFIER, SESSION_CONFIG } from './constants';

export const getCoachmarkVisibilityStatus = (coachmarkId: string) => {
  try {
    const { totalSessions = 0, viewsInCurrentSession = 0 } = JSON.parse(
      Storage.getItem<string>(`${COACHMARK_IDENTIFIER}${coachmarkId}`, '{}') || '{}'
    );

    return { totalSessions, viewsInCurrentSession };
  } catch (e) {
    return { totalSessions: 0, viewsInCurrentSession: 0 };
  }
};

export const setCoachmarkVisibilityStatus = ({
  coachmarkId,
  viewsInCurrentSession,
  totalSessions,
}: {
  coachmarkId: string;
  viewsInCurrentSession: number;
  totalSessions: number;
}) => {
  try {
    Storage.setItem(
      `${COACHMARK_IDENTIFIER}${coachmarkId}`,
      JSON.stringify({
        totalSessions: totalSessions,
        viewsInCurrentSession: viewsInCurrentSession,
      })
    );
  } catch (e) {
    // do nothing
  }
};

export const storeCoachmarkVisible = (coachmarkId: string) => {
  // check for exisiting coachmark visibility
  const { totalSessions, viewsInCurrentSession } = getCoachmarkVisibilityStatus(coachmarkId);

  // update coachmark views in session count
  setCoachmarkVisibilityStatus({
    coachmarkId,
    totalSessions,
    viewsInCurrentSession: viewsInCurrentSession + 1,
  });
};

export const storeCoachmarkInteractionComplete = (coachmarkId: string) => {
  // check for exisiting coachmark visibility
  const { totalSessions = 0 } = getCoachmarkVisibilityStatus(coachmarkId);

  // update coachmark visibility to max allowed session visiblity
  setCoachmarkVisibilityStatus({
    coachmarkId,
    totalSessions,
    viewsInCurrentSession: SESSION_CONFIG.MAX_OCCURENCE_IN_SESSION,
  });
};

export const updateCoachmarkSessionCount = (coachmarkId: string) => {
  // check for exisiting coachmark visibility
  const { totalSessions = 0, viewsInCurrentSession = 0 } =
    getCoachmarkVisibilityStatus(coachmarkId);

  const currentSessionCount = viewsInCurrentSession === 0 ? totalSessions : totalSessions + 1;

  // update session count and reset views in the session
  setCoachmarkVisibilityStatus({
    coachmarkId,
    totalSessions: currentSessionCount,
    viewsInCurrentSession: 0,
  });

  return currentSessionCount;
};

export const isCoachmarkStepComplete = (coachmarkId: string) => {
  const { totalSessions, viewsInCurrentSession } = getCoachmarkVisibilityStatus(coachmarkId);

  return (
    viewsInCurrentSession < SESSION_CONFIG.MAX_OCCURENCE_IN_SESSION &&
    totalSessions <= SESSION_CONFIG.MAX_ELIGIBLE_SESSIONS
  );
};

export const updateSessionCount = () => {
  if (window && window.sessionStorage) {
    const isFirstPLP = window.sessionStorage.getItem(COACHMARK_SESSION_IDENTIFIER) === '1';

    if (isFirstPLP === false) {
      window.sessionStorage.setItem(COACHMARK_SESSION_IDENTIFIER, '1');
      const sessionInfoByCoachmark = PLP_COACHMARK_VARIANTS.map(updateCoachmarkSessionCount);
      const isSessionValid = sessionInfoByCoachmark.find(
        (sessionCount) => sessionCount < SESSION_CONFIG.MAX_ELIGIBLE_SESSIONS
      );

      // return if any of the coachmark step can be shown to the current user
      return isEmpty(isSessionValid);
    }

    // return true for the first session/ access to coachmarks
    return true;
  }
};
